"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function compileFontStyle(branding) {
    const { mainFont = {} } = branding;
    const color = mainFont === null || mainFont === void 0 ? void 0 : mainFont.color;
    const defaultSelected = mainFont === null || mainFont === void 0 ? void 0 : mainFont.defaultSelected;
    return (0, utils_1.process)({
        'main-font': defaultSelected ? `${defaultSelected}, Arial, Helvetica, sans-serif` : undefined,
        'text-color': color
    });
}
exports.default = compileFontStyle;
